<template>
    <a-drawer
        v-model:visible="isOpen"
		class="drawer"
		width="100%"
        :placement="placement"
        :headerStyle="{ background: 'transparent'}"
	>
		<slot></slot>
	</a-drawer>
</template>
<script>
import { computed } from 'vue';
export default {
    name: 'HeaderBlock',
    props: {
        open: Boolean,
        placement: String
    },
    emits: ["update:open"],
    setup(props, { emit }) {
        const isOpen = computed({
            get: () => props.open,
            set: (value) => emit("update:open", value),
        });

        return { isOpen };
    },
}
</script>
<style lang="scss">
.drawer {
    .ant-drawer-header-title {
        padding-top: 10px;
        justify-content: right;
    }

    .ant-drawer-close {
        color: #fff;
        font-size: 24px;
    }

        .ant-drawer-content {
            background: #C42D99;
            background: linear-gradient(180deg,rgba(196, 45, 153, 1) 0%, rgba(1, 1, 1, 1) 100%);
        }
    
}
</style>